var $$ = $$ || {};

$$.Popup = class Popup {
	constructor (root) {
		this.root = root;

		this.popupContentProperty = {};

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_cacheNodes () {
		this.nodes = {
			contents: this.root.find('.js-popup-content'),
			close: this.root.find('.js-close-popup')
		};
	}

	_bindEvents () {
		this.root.on('click', (event) => {
			var targetElement = $(event.target);

			if ( targetElement.get(0) == this.root.get(0) || targetElement.get(0) == this.nodes.close.get(0) ) {
				this._closePopup();
			}
		});

		this.nodes.contents.on('partnerFormSubmit', () => {
			this._closePopup();
		});
	}

	_ready () {
		this.nodes.contents.each((index, content) => {
			this.popupContentProperty[ $(content).data('popup-content-name') ] = $(content).css('display');
			$(content).css({ display: 'none' });
		});
	}

	openPopup(popupContentName) {
		$('body').css({ overflow: 'hidden' });
		this.root.show();

		this.root.find('.js-popup-content[data-popup-content-name=' + popupContentName + ']').css({
			display: this.popupContentProperty[popupContentName]
		});
	}

	_closePopup() {
		$('body').css({ overflow: 'auto' });
		this.root.hide();

		this.nodes.contents.css({ display: 'none' });
	}
};
